import React, { useMemo, useState } from "react";
import {
  UIPopover,
  UIButton,
  SettingOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
} from "ui";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import {
  DISPLAY_TABLE_FIELDS,
  DISPLAY_TYPE,
  SEARCH_PARAMS,
} from "../../../constants/consts";
import { switchDisplayType } from "../../../store/slices/PagePaginagionSlice";
import { SearchByCheckbox } from "./searchByCheckbox/SearchByCheckbox";
import { DisplayFieldCheckbox } from "./displayFieldCheckbox/DisplayFieldCheckbox";
import { useTranslation } from "react-i18next";
import "./CatalogControl.sass";

interface CatalogControlProps {
  isDownload?: boolean;
  isSetConfig?: boolean;
  isSetDisplay?: boolean;
  className?: string;
  btnClassName?: string;
}

export const CatalogControl = ({
  isSetConfig = true,
  isSetDisplay = true,
  className = "catalog-control-inline",
  btnClassName = "",
}: CatalogControlProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { displayType } = useAppSelector((state) => state.page);
  const [open, setOpen] = useState(false);

  const resolvedBtnClassName = useMemo(
    () => [btnClassName, "catalogControlAnt__iconBtn text-colored"].filter(Boolean).join(" "),
    [btnClassName]
  );

  const updateDisplay = () => {
    dispatch(switchDisplayType());
  };

  const settingsContent = (
    <div className="catalogControlAnt__popoverContent">
      <h3 className="catalogControlAnt__popoverTitle">{t("title")}</h3>

      {displayType === DISPLAY_TYPE.TABLE && (
        <div className="catalogControlAnt__section">
          <span className="catalogControlAnt__sectionTitle">{t("showColumns")}</span>
          <div className="catalogControlAnt__options">
            {Object.keys(DISPLAY_TABLE_FIELDS).map((key) => (
              <DisplayFieldCheckbox key={`display-${key}`} displayItem={key} />
            ))}
          </div>
        </div>
      )}

      <div className="catalogControlAnt__section">
        <span className="catalogControlAnt__sectionTitle">{t("searchBy")}</span>
        <div className="catalogControlAnt__options">
          {Object.keys(SEARCH_PARAMS).map((key) => (
            <SearchByCheckbox key={`search-by-${key}`} filterItem={key} />
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className={`${className} ${open ? "active" : ""}`}>
      {isSetConfig && (
        <UIPopover
          trigger="click"
          open={open}
          placement="bottomLeft"
          overlayClassName="catalogControlAnt__popover"
          onOpenChange={setOpen}
          content={settingsContent}
        >
          <UIButton
            type="button"
            variant="outlined"
            className={resolvedBtnClassName}
            icon={<SettingOutlined />}
            aria-label={t("title")}
          />
        </UIPopover>
      )}
      {isSetDisplay && (
        <UIButton
          type="button"
          variant="outlined"
          className={resolvedBtnClassName}
          onClick={updateDisplay}
          icon={
            displayType === DISPLAY_TYPE.TABLE ? (
              <AppstoreOutlined />
            ) : (
              <UnorderedListOutlined />
            )
          }
          aria-label={
            displayType === DISPLAY_TYPE.TABLE
              ? "Switch to grid view"
              : "Switch to table view"
          }
        />
      )}
    </div>
  );
};
